import { ToastContainer } from 'react-toastify';
import DebugComponent from './DebugComponent';
import NavigationComponent from './common/NavigationComponent';
import HomeComponent from './features/Home';
import ProfileComponent from './features/Profile';
import RoundTableProfile from './features/RoundTableProfile';
import ProjectsComponent from './features/Projects';
import ProjectDetailsComponent from './features/ProjectDetails';
import RechnungDetailsComponent from './features/RechnungDetails';
import TischkontenComponent from './features/Tischkonten';
import TischkontenDetailsComponent from './features/TischkontenDetails';
import ImportDetailsComponent from './features/ImportDetails';
import ImportListComponent from './features/ImportList';
import TravelbingoComponent from './features/Travelbingo';
import TravelbingoEvaluationsComponent from './features/TravelbingoEvaluations';
import TravelbingoEvaluationDetailsComponent from './features/TravelbingoEvaluationDetails';
import SubscriptionsComponent from './features/Subscriptions';
import SubscriptionImportWizard from './features/SubscriptionImportWizard';
import { JSX } from 'react';

interface NavigationRoute {
    path: string;
    component: JSX.Element;
    matchType?: 'startsWith' | 'exact';
}

const navigationRoutes: NavigationRoute[] = [
    { path: "/home", component: <HomeComponent /> },
    { path: "/tischkonten/details/", component: <TischkontenDetailsComponent /> },
    { path: "/tischkonten", component: <TischkontenComponent />, matchType: "exact" },
    { path: "/my-profile", component: <ProfileComponent /> },
    { path: "/settings", component: <RoundTableProfile /> },
    { path: "/projects", component: <ProjectsComponent /> },
    { path: "/rechnungdetails", component: <RechnungDetailsComponent /> },
    { path: "/projectdetails", component: <ProjectDetailsComponent /> },
    { path: "/travelbingo/evaluations/", component: <TravelbingoEvaluationDetailsComponent /> },
    { path: "/travelbingo/evaluations", component: <TravelbingoEvaluationsComponent />, matchType: "exact" },
    { path: "/travelbingo", component: <TravelbingoComponent />, matchType: "exact" },
    { path: "/debug", component: <DebugComponent /> },
    { path: "/imports/tischkonten/", component: <ImportDetailsComponent /> },
    { path: "/imports/tischkonten", component: <ImportListComponent />, matchType: "exact" },
    { path: "/subscriptions/import", component: <SubscriptionImportWizard />, matchType: "exact" },
    { path: "/subscriptions", component: <SubscriptionsComponent />, matchType: "exact" }
];

export const ContentComponents = () => {
    return (
        <main style={styles.main}>
            {navigationRoutes.map(({ path, component, matchType }) => (
                <NavigationComponent navPath={path} key={path} matchType={matchType}>
                    {component}
                </NavigationComponent>
            ))}
            
            <ToastContainer />
        </main>
    );
};

const styles = {
    main: {
        padding: '0 20px', // Adds 20px padding to the left and right
        backgroundColor: '#f8f9fa', // Matches the overall background color
        minHeight: '100vh', // Ensures the main element covers the full viewport height
    } as React.CSSProperties,
};